import React from 'react';
import { NavLink } from 'react-router-dom';
import { useAuthStore } from '@stores/authStore';

export const Sidebar: React.FC = () => {
  const { user } = useAuthStore();

  const menuItems = [
    { name: 'Dashboard', path: '/' },
    { name: 'Applications', path: '/applications' },
    { name: 'Customers', path: '/customers' },
    { name: 'Installs', path: '/licenses' },
    { name: 'Claim Codes', path: '/claim-codes' },
    { name: 'Invoices', path: '/invoices' },
    { name: 'Analytics', path: '/analytics' },
    { name: 'Audit Log', path: '/audit-log' },
  ];

  return (
    <div className="w-64 bg-gray-900 text-white flex flex-col">
      <div className="px-6 py-6 border-b border-gray-800">
        <h1 className="text-2xl font-bold">Control Plane</h1>
        <p className="text-sm text-gray-400 mt-1">Admin Dashboard</p>
      </div>

      <nav className="flex-1 px-3 py-6 space-y-1">
        {menuItems.map((item) => (
          <NavLink
            key={item.path}
            to={item.path}
            className={({ isActive }) =>
              `block px-3 py-2 rounded text-gray-100 transition ${
                isActive ? 'bg-gray-800 font-semibold' : 'hover:bg-gray-800'
              }`
            }
          >
            {item.name}
          </NavLink>
        ))}
      </nav>

      <div className="px-6 py-4 border-t border-gray-800">
        <div className="text-sm text-gray-400">Logged in as</div>
        <div className="text-white font-medium mt-1 text-sm break-all">{user?.email || 'Unknown'}</div>
      </div>
    </div>
  );
};
